var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1StTierCopy23X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "47px",
    viewBox: "0 0 50 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Map/Pin/1st Tier Copy 2@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.1434251,37.9228313 C27.19309,39.9815184 25.1091562,41.8570588 23.0245962,43.5169862 C22.2938488,44.0988776 21.6139262,44.6131781 21.0014944,45.0554899 C20.6282804,45.3250334 20.356333,45.5133822 20.2023559,45.6160336 C19.5594234,46.0446552 18.7218266,46.0446552 18.0788942,45.6160336 C17.9249171,45.5133822 17.6529697,45.3250334 17.2797556,45.0554899 C16.6673238,44.6131781 15.9874012,44.0988776 15.2566538,43.5169862 C13.1720938,41.8570588 11.0881601,39.9815184 9.13782495,37.9228313 C3.44990926,31.9189203 0,25.5940867 0,19.1406247 C0,8.56954955 8.56954983,0 19.140625,0 C29.7117002,0 38.28125,8.56954955 38.28125,19.1406247 C38.28125,25.5940867 34.8313408,31.9189203 29.1434251,37.9228313 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.3%",
    y: "-1.1%",
    width: "102.6%",
    height: "102.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.-SPS-Provider-Profile",
    transform: "translate(-827.000000, -504.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Location",
    transform: "translate(610.000000, 340.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map/Pin/1st-Tier",
    transform: "translate(197.000000, 164.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7313901,44.8588316 C38.3271488,46.5744041 36.8267165,48.1373545 35.3258333,49.5206273 C34.7996952,50.0055368 34.3101509,50.4341206 33.8692,50.8027138 C33.6004859,51.0273333 33.4046838,51.1842906 33.2938202,51.2698335 C32.8309089,51.6270182 32.2278392,51.6270182 31.7649278,51.2698335 C31.6540643,51.1842906 31.4582622,51.0273333 31.1895481,50.8027138 C30.7485972,50.4341206 30.2590529,50.0055368 29.7329148,49.5206273 C28.2320316,48.1373545 26.7315993,46.5744041 25.327358,44.8588316 C21.2320587,39.8555724 18.748124,34.5848777 18.748124,29.2069927 C18.748124,20.3977633 24.9181999,13.256472 32.529374,13.256472 C40.1405482,13.256472 46.310624,20.3977633 46.310624,29.2069927 C46.310624,34.5848777 43.8266894,39.8555724 39.7313901,44.8588316 Z",
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.100000001,
    transform: "translate(32.529374, 32.397097) rotate(-314.000000) translate(-32.529374, -32.397097) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#00A69E",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.140625,26.7968748 C14.9121949,26.7968748 11.484375,23.3690549 11.484375,19.1406248 C11.484375,14.9121946 14.9121949,11.4843748 19.140625,11.4843748 C23.3690551,11.4843748 26.796875,14.9121946 26.796875,19.1406248 C26.796875,23.3690549 23.3690551,26.7968748 19.140625,26.7968748 Z",
    id: "Oval",
    fill: "#FFFFFF"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1StTierCopy23X);
export default __webpack_public_path__ + "static/media/1st_Tier_Copy_2@3x.c1f6080baee4d5ff63c40868f916bd12.svg";
export { ForwardRef as ReactComponent };